import React, { useEffect, useState } from "react";
import {
  getDocDataSnap,
  queryAllDocsByFieldSnap,
} from "../../../utils/firebase/Firebase.utils";
import WorkPermitCards from "../WorkPermits/WorkPermitCards";
import { slicedData } from "../../../utils/EleghoUtils";
import BentoTable from "../../../components/BentoTable";
import PageModal from "../Components/PageModal";
import WorkPermitDetails from "../WorkPermits/WorkPermitDetails";
import ConcernsCard from "../Concerns/ConcernsCard";
import ConcernsPageDetails from "../Concerns/ConcernsPageDetails";

export default function ResidentConcerns({ identifier }) {
  const [concerns, setConcerns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [numberOfItemPerPage, setNumberOfItemPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedForView, setSelectedForView] = useState(null);
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    const fetchConcerns = async () => {
      await queryAllDocsByFieldSnap(
        "concerns",
        "identifier",
        "==",
        identifier,
        (data) => {
          setConcerns(data);
          setLoading(false);
        }
      );
    };
    fetchConcerns();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const dataSliced = slicedData(concerns, numberOfItemPerPage, currentPage);

  const handleViewMode = (concern) => {
    setViewMode(true);
    setSelectedForView(concern);
  };

  return (
    <div>
      <BentoTable
        label="Concerns"
        data={dataSliced}
        numberOfItemPerPage={numberOfItemPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      >
        {concerns.map((concern, index) => (
          <div onClick={() => handleViewMode(concern)} key={index}>
            <ConcernsCard concern={concern} />
          </div>
        ))}
      </BentoTable>

      {viewMode && (
        <PageModal>
          <ConcernsPageDetails
            concern={selectedForView}
            setViewMode={() => setViewMode(false)}
          />
        </PageModal>
      )}
    </div>
  );
}
